import React from 'react';

import SelectedItemsControls from '@Containers/ResultToolbar/SelectedItemsControls';
import RsTableToolbarButton from '@Pages/RetroSynthesis/components/RsTableToolbarButton';
import Auth from '@Services/Auth';
import PropTypes from 'prop-types';
import { FEATURES } from '@Constants/rx-ui/constants';
import RsTableToolbar from '@Pages/RetroSynthesis/components/RsTableToolbar';
import Button from '@Components/Button';

import './RsProjectTableToolBar.theme.scss';

function RsProjectTableToolBar({ onDeleteClick, selectedCount, onSelectAllClick, isAllSelected, onImport }) {
  const importEnabled = Auth.isFeatureEnabled(FEATURES.enableProjectImport);
  return (
    <RsTableToolbar>
      <div className="rs-table-toolbar__left-controls">
        <SelectedItemsControls
          checkAllItems={() => onSelectAllClick()}
          allItemsSelected={!!isAllSelected}
          currentSelectedItems={selectedCount}
          someItemsSelected={selectedCount > 0 && !isAllSelected}
        />
        <RsTableToolbarButton icon="trash" label="Delete" disabled={selectedCount <= 0} onClick={() => onDeleteClick()} />
      </div>
      <div className="rs-table-toolbar__center-controls" />
      <div className="rs-table-toolbar__right-controls">
        {importEnabled && (
          <Button
            buttonConfig={{
              label: 'Import',
              type: 'link',
              size: 'sm',
              e2eName: 'rs-projects-table-import',
              ariaLabel: 'Import',
            }}
            iconConfig={{
              position: 'after',
              name: 'download',
              size: 'sm',
            }}
            onClick={onImport}
          />
        )}
      </div>
    </RsTableToolbar>
  );
}
export default RsProjectTableToolBar;

RsProjectTableToolBar.defaultProps = {
  onSelectAllClick: () => null,
  onDeleteClick: () => null,
  onImport: () => null,
  selectedCount: 0,
  isAllSelected: false,
};

RsProjectTableToolBar.propTypes = {
  selectedCount: PropTypes.number,
  isAllSelected: PropTypes.bool,
  onSelectAllClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  onImport: PropTypes.func,
};
